/**
 * Reading Progress Bar
 * Shows a progress bar at the top of the page indicating scroll progress
 */

(function() {
  'use strict';

  // Only show on post pages
  if (!document.querySelector('.post-single')) {
    return;
  }

  // Create progress bar element
  const progressBar = document.createElement('div');
  progressBar.className = 'reading-progress';
  progressBar.setAttribute('role', 'progressbar');
  progressBar.setAttribute('aria-label', 'Reading progress');
  progressBar.setAttribute('aria-valuemin', '0');
  progressBar.setAttribute('aria-valuemax', '100');

  const progressFill = document.createElement('div');
  progressFill.className = 'reading-progress-fill';
  progressBar.appendChild(progressFill);

  document.body.appendChild(progressBar);

  // Calculate and update progress
  function updateProgress() {
    // Get scroll position
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Calculate percentage
    const scrollableHeight = documentHeight - windowHeight;
    const progress = (scrollTop / scrollableHeight) * 100;

    // Update progress bar
    const clampedProgress = Math.min(Math.max(progress, 0), 100);
    progressFill.style.width = clampedProgress + '%';
    progressBar.setAttribute('aria-valuenow', Math.round(clampedProgress));
  }

  // Throttle scroll event for better performance
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    if (scrollTimeout) {
      window.cancelAnimationFrame(scrollTimeout);
    }
    scrollTimeout = window.requestAnimationFrame(updateProgress);
  }, { passive: true });

  // Also update on resize
  window.addEventListener('resize', updateProgress, { passive: true });

  // Initial update
  updateProgress();
})();
